import type { SVGProps } from "react";

export const NoVoucherIllustraction = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="313"
      height="235"
      fill="none"
      viewBox="0 0 313 235"
      {...props}
    >
      <path
        fill="#DEF2FF"
        d="m258 41 3.116 18.917c2.787 16.92 16.048 30.18 32.967 32.967L313 96l-18.917 3.116c-16.919 2.787-30.18 16.048-32.967 32.967L258 151l-3.116-18.917c-2.787-16.919-16.048-30.18-32.967-32.967L203 96l18.917-3.116c16.919-2.787 30.18-16.048 32.967-32.967zM220 0l.963 5.847a12.36 12.36 0 0 0 10.19 10.19L237 17l-5.847.963a12.36 12.36 0 0 0-10.19 10.19L220 34l-.963-5.847a12.36 12.36 0 0 0-10.19-10.19L203 17l5.847-.963a12.36 12.36 0 0 0 10.19-10.19zM17 62l.963 5.847a12.36 12.36 0 0 0 10.19 10.19L34 79l-5.847.963a12.36 12.36 0 0 0-10.19 10.19L17 96l-.963-5.847a12.36 12.36 0 0 0-10.19-10.19L0 79l5.847-.963a12.36 12.36 0 0 0 10.19-10.19zM62.5 145l.77 20.81c.47 12.731 10.662 22.942 23.363 23.407L108 190l-21.367.783c-12.701.465-22.893 10.676-23.364 23.407L62.5 235l-.77-20.81c-.47-12.731-10.662-22.942-23.363-23.407L17 190l21.367-.783c12.701-.465 22.893-10.676 23.364-23.407z"
      ></path>
      <g clipPath="url(#clip0_6314_105403)">
        <path
          fill="#0648FF"
          d="M202 68.05c-.65 0-1.3.25-1.75.75l-3.95 3.95c-1 1-2.55 1-3.55 0l-3.95-3.95c-1-1-2.55-1-3.55 0l-3.95 3.95c-1 1-2.55 1-3.55 0l-3.95-3.95c-1-1-2.55-1-3.55 0l-3.95 3.95c-1 1-2.55 1-3.55 0l-3.95-3.95c-1-1-2.55-1-3.55 0l-3.95 3.95c-1 1-2.55 1-3.55 0l-4-4c-1-1-2.55-1-3.55 0l-3.95 4c-1 1-2.55 1-3.55 0l-3.95-4c-1-1-2.55-1-3.55 0l-3.95 4c-1 1-2.55 1-3.55 0l-3.95-4c-.45-.45-1.1-.7-1.75-.7V166c.65 0 1.3-.25 1.75-.75l3.95-3.95c1-1 2.55-1 3.55 0l3.95 3.95c1 1 2.55 1 3.55 0l3.95-3.95c1-1 2.55-1 3.55 0l3.95 3.95c1 1 2.55 1 3.55 0l3.95-3.95c1-1 2.55-1 3.55 0l3.95 3.95c1 1 2.55 1 3.55 0l3.95-3.95c1-1 2.55-1 3.55 0l3.95 3.95c1 1 2.55 1 3.55 0l3.95-3.95c1-1 2.55-1 3.55 0l3.95 3.95c1 1 2.55 1 3.55 0l3.95-3.95c1-1 2.55-1 3.55 0l3.95 3.95c.5.5 1.15.75 1.75.75V68.05zM182 142h-50c-2.75 0-5-2.25-5-5s2.25-5 5-5h50c2.75 0 5 2.25 5 5s-2.25 5-5 5m0-20h-50c-2.75 0-5-2.25-5-5s2.25-5 5-5h50c2.75 0 5 2.25 5 5s-2.25 5-5 5m0-20h-50c-2.75 0-5-2.25-5-5s2.25-5 5-5h50c2.75 0 5 2.25 5 5s-2.25 5-5 5"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_6314_105403">
          <path fill="#fff" d="M97 57h120v120H97z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
